import { IChallenge, IGetChallengesParams } from 'models/Challenges'
import { IPayload } from 'models/Global'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class ChallengesApi {
  constructor(private axios: AxiosService) {}

  getChallenges = async (params?: IGetChallengesParams) => {
    const response = await this.axios.get<IPayload<IChallenge[]>>(
      Endpoints.getChallenges,
      params,
    )
    return response
  }
}
